module.exports = __webpack_public_path__ + "static/media/logo_es@2x.b14b4305.png";